<template>
  <div class="header">
    <div class="center">
      <div class="left">
        <button @click="$router.push('/', () => {})" v-if="this.currentWorkspace && this.currentWorkspace.logoUrl" class="headerLogo profileAvatar" v-bind:style="{ backgroundImage: `url(${this.currentWorkspace.logoUrl})` }"></button>
        <img v-else @click="$router.push('/', () => {})" class="headerLogo" src="~images/logo.svg" alt="" />
        <div v-if="isRetroPage" class="headerRetro">
          <input tabindex="-1" type="text" placeholder="Retro name..." @keyup.enter="saveRetroTitle" @blur="saveRetroTitle" @change="saveRetroTitle" :value="retro.retroName" />
          <div class="headerRetro_workspace">
            <span class="headerWorkspace_title" v-if="currentWorkspace"> {{ currentWorkspace.name }} • </span>
            <span v-if="retro.createdDate">
              {{ formattedData(retro.createdDate && retro.createdDate.seconds) }}
            </span>
          </div>
        </div>
        <div v-else-if="currentWorkspace" class="headerWorkspace">
          <button
            class="headerWorkspace_title"
            @click="
              () => {
                $router.push('/', () => {});
              }
            "
          >
            {{ currentWorkspace.name }}
          </button>
          <template v-if="allWorkspaces.length > 1">
            <!-- <div class="header_logo_arrow"></div> -->
            <div class="submenu">
              <template v-for="workspaceId in allWorkspaces">
                <button
                  v-if="workspaces[workspaceId] && workspaces[workspaceId].name"
                  :key="workspaceId"
                  :disabled="workspaceId === currentWorkspace.id"
                  @click="
                    () => {
                      $store.dispatch('action_SetCurrentWorkspace', { workspaceId }).then(() => {
                        $router.push(`/${workspaceId}`, () => {});
                      });
                    }
                  "
                >
                  {{ workspaces[workspaceId] && workspaces[workspaceId].name }}
                </button>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div class="header_right">
        <div v-if="isRetroPage" class="header_retroButtons">
          <button :class="[copyButtonActiveClass, 'header_copy']" v-clipboard="fullUrl" v-clipboard:success="clipboardSuccessHandler">
            <img src="~images/shape.svg" alt="" />
          </button>
          <button v-if="isAdmin && lockRetro" :class="[retro.locked ? 'locked' : '', 'header_lock']" @click="lockRetro">
            <svg width="12px" height="16px" viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path class="header_lock_icon" d="M9.46066304,16 C10.7194458,16 11.3369619,15.374567 11.3369619,14.0128649 L11.3369619,8.24146462 C11.3369619,7.03809995 10.8381989,6.40475012 9.84067293,6.28599703 L9.84067293,4.49678377 C9.84067293,1.47253835 7.79811974,0 5.66848095,0 C3.53884216,0 1.49628897,1.47253835 1.49628897,4.49678377 L1.49628897,6.28599703 C0.490846116,6.40475012 0,7.03809995 0,8.24146462 L0,14.0128649 C0,15.374567 0.617516081,16 1.87629886,16 L9.46066304,16 Z M8.1306284,6.26224641 L3.2063335,6.26224641 L3.2063335,4.36219693 C3.2063335,2.62840178 4.30677882,1.65462642 5.66848095,1.65462642 C7.03018308,1.65462642 8.1306284,2.62840178 8.1306284,4.36219693 L8.1306284,6.26224641 Z M9.05690252,14.3770411 L2.28005938,14.3770411 C1.94755072,14.3770411 1.78129639,14.2187036 1.78129639,13.8149431 L1.78129639,8.43938644 C1.78129639,8.03562593 1.94755072,7.89312222 2.28005938,7.89312222 L9.05690252,7.89312222 C9.39732806,7.89312222 9.55566551,8.03562593 9.55566551,8.43938644 L9.55566551,13.8149431 C9.55566551,14.2187036 9.39732806,14.3770411 9.05690252,14.3770411 Z" id="Shape"></path>
            </svg>
          </button>
        </div>
        <div class="headerUserLogo" v-if="currentUser">
          <template v-if="userInfoLoaded">
            <div class="headerUserLogo_img" v-bind:style="{ backgroundImage: `url(${photoURL})` }">
              {{ photoURL ? '' : String(userName).substring(0, 1) }}
            </div>
            <div class="headerUserLogoMenu">
              <router-link to="/profile">Profile</router-link>
              <template v-if="isAdmin">
                <router-link v-bind:to="`/${currentWorkspace.id}/team`">
                  Team
                </router-link>
              </template>
              <button type="button" class="red" @click="logout">Sign Out</button>
            </div>
          </template>
        </div>
        <router-link v-else v-bind:to="`/login`" v-slot="{ href, isActive, navigate }">
          <a v-bind:href="href" @click="navigate" class="button header_login">
            Log In
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { AUTH } from 'src/firebase-config';
import _get from 'lodash.get';
import mixins from '../../mixins';

export default {
  mixins: [mixins],
  props: ['isRetroPage', 'retro', 'saveRetroTitle', 'lockRetro', 'isOldRetroPage'],
  data() {
    return {
      userLogoSrc: '',
      copyButtonActiveClass: '',
      fullUrl: window.location.href
    };
  },
  computed: {
    ...mapState(['currentUser', 'currentWorkspace', 'userInfo', 'userInfoLoaded', 'workspaces', 'isAdmin']),
    allWorkspacesLoaded: function () {
      return Object.keys(this.workspaces).length !== 0;
    },
    userVerified: function () {
      return AUTH.currentUser.emailVerified;
    },
    photoURL: function () {
      return _get(this.userInfo, 'photoURL', null);
    },
    userName: function () {
      return _get(this.userInfo, 'name', null);
    },
    // workspacesList: function() {
    //   return _get(this.userInfo, 'workspaces', [])
    // }
    userLogedIn: function () {
      return AUTH.currentUser;
    }
  },
  methods: {
    logout() {
      AUTH.signOut()
        .then(() => {
          this.$store.dispatch('action_clearData');
          this.$router.push('/login');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clipboardSuccessHandler() {
      this.copyButtonActiveClass = 'active';

      setTimeout(() => {
        this.copyButtonActiveClass = '';
      }, 1000);
    }
    // saveRetroTitle(event) {
    //   retrosCollection
    //     .doc(this.retroID)
    //     .update({
    //       retroName: this.retro.retroName
    //     })
    //     .then(() => {
    //       event.target.blur();
    //       this.updatePageTitle();
    //     });
    // },
    // updatePageTitle() {
    //   document.title = this.retro.retroName.trim() ? '${this.retro.retroName} - EZ Retro` : 'EZ Retro';
    // }
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
</style>
